import { filter, go, html, strMap } from 'fxjs/es';
import { zipWithIndex } from 'fxjs/es/Lazy';
import { NessCoreTmplS } from '../../../../../Core/S/Tmpl/module/NessCoreTmplS.js';
import { NessAppPlusHomeConstantS } from '../Constant/module/NessAppPlusHomeConstantS.js';
import { NessAppPlusHomeTmplS } from './module/NessAppPlusHomeTmplS.js';
import { NessConstantS } from '../../../../../S/Constant/module/NessConstantS.js';

export const home = ({
  crew_brand_title_default,
  cate_lists,
  special_menus,
  is_mobile,
  plus_crew,
  banners,
  recent_products,
  limited_products,
  limited_product_count,
  best_products,
  lives,
  reviews,
  brandedContents,
  crew_like,
  is_custom_store,
  custom_products,
  domain_name,
}) => {
  const dataArray = [
    {
      option: {},
      template: NessAppPlusHomeTmplS.recentProduct,
      use_max_width: true,
      data: recent_products,
    },
    {
      option: { ...NessConstantS.NESS_CUSTOM_HARDCODING()[domain_name], is_mobile },
      template: NessAppPlusHomeTmplS.customProduct,
      use_max_width: true,
      data: is_custom_store ? custom_products : [],
    },
    {
      option: { limited_product_count, is_mobile },
      template: NessAppPlusHomeTmplS.limitedProduct,
      use_max_width: false,
      data: limited_products,
    },
    {
      option: {},
      template: NessAppPlusHomeTmplS.bestProduct,
      use_max_width: true,
      data: best_products,
      condition: NessAppPlusHomeConstantS.isBestSellerShow,
    },
    {
      option: { plus_crew, is_mobile },
      template: NessAppPlusHomeTmplS.brandedContent,
      use_max_width: false,
      data: brandedContents,
    },
    { option: {}, template: NessAppPlusHomeTmplS.live, use_max_width: true, data: lives },
    {
      option: {},
      template: NessAppPlusHomeTmplS.review,
      use_max_width: true,
      data: reviews,
    },
  ];

  return html`
    <div class="ness-plus-home">
      <div class="ness-plus-home__section">
        ${NessAppPlusHomeTmplS.crewBillboard({ plus_crew, banners, is_mobile, crew_like })}
        <div class="ness-plus-home__menus">
          ${NessCoreTmplS.getDefaultHeaderBottom_category({
            title: crew_brand_title_default,
            special_menus,
            cate_lists,
            is_mobile,
          })}
        </div>
      </div>
      ${go(
        dataArray,
        filter((home_data) => {
          if (typeof home_data.condition !== 'undefined') {
            return home_data.condition && home_data.data.length;
          }
          return home_data.data.length;
        }),
        zipWithIndex,
        strMap(([idx, home_data]) => {
          return html`
            <div
              class="ness-plus-home__section"
              data-max-width="${home_data.use_max_width}"
              data-index="${idx}"
            >
              ${home_data.template(home_data.data, home_data.option)}
            </div>
          `;
        }),
      )}
    </div>
  `;
};
